export enum DocumentKinds {
  Referral = 'REFERRAL',
}

export enum LabelingJobsFailureReasons {
  IncompleteFields = 'INCOMPLETE_FIELDS',
  OcrFailure = 'OCR_FAILURE',
}

export enum LabelingJobsResolutions {
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
  Superseded = 'SUPERSEDED',
}

export interface FilterOptions {
  after?: Date;
  before?: Date;
  kind?: DocumentKinds[];
  limit?: number;
  offset?: number;
  failureReason?: LabelingJobsFailureReasons;
  isClaimed?: boolean;
  ehrInstanceIds?: string[];
  organizationIds?: string[];
  practiceGroupIds?: string[];
  practiceIds?: string[];
}

export interface LabelingJob {
  id: string;
  created: Date;
  documentId: string;
  documentFindingsId: string;
  kind: DocumentKinds;
  failureReason: LabelingJobsFailureReasons;
  claimed: Date;
  claimedByUserId: string | null;
}

export interface LabelingJobsHistory extends LabelingJob {
  resolution: LabelingJobsResolutions;
  jobCreated: Date;
  resolvedByUserId: string;
  supersededByUserId: string;
}
